const VISUAL_SCENARIO_ALIASES = new Set(["Presenter", "Background", "Product"]);

const SEGMENT_SCENARIO_TYPES = new Set(["Voice Over", "Text Overlay", "Visual"]);

const NEUTRAL_TIME_FRAMES = new Set(["All", "None"]);

/** Maps overview Scenario to the Examples query `segment2` Groupby dimension label. */
export function resolveTopicDetailSegment2(scenario: string, featureTimeFrame: string): string {
  const selectedScenario = VISUAL_SCENARIO_ALIASES.has(scenario) ? "Visual" : scenario;

  if (selectedScenario === "Brand Metadata") return "Link";
  if (selectedScenario === "Social Post Body") return "Primary";
  if (selectedScenario === "Social Post Headline") return "Headline";

  if (SEGMENT_SCENARIO_TYPES.has(selectedScenario) && NEUTRAL_TIME_FRAMES.has(featureTimeFrame)) {
    return `Full ${selectedScenario}`;
  }

  if (SEGMENT_SCENARIO_TYPES.has(selectedScenario)) {
    return `Exact ${selectedScenario} (${featureTimeFrame})`;
  }

  return "All";
}
